/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_MenuInputs */

const en_views_menu = /** @type {(inputs: Views_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Views`)
};

const de_views_menu = /** @type {(inputs: Views_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansichten`)
};

/**
* | output |
* | --- |
* | "Views" |
*
* @param {Views_MenuInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_menu = /** @type {((inputs?: Views_MenuInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_MenuInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_menu(inputs)
	return en_views_menu(inputs)
});